module.exports = __webpack_public_path__ + "static/media/doctorsSampleUpload.c281c449.xlsx";